import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const LaptopMinimal = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '24',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 24 25'
    >
      <path
        d='M2 20.18H22M5 4.17999H19C20.1046 4.17999 21 5.07542 21 6.17999V14.18C21 15.2846 20.1046 16.18 19 16.18H5C3.89543 16.18 3 15.2846 3 14.18V6.17999C3 5.07542 3.89543 4.17999 5 4.17999Z'
        stroke={primaryColorToUse}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
